import { USER_STATUS } from '../constants';

const userStatusReducer = (state = {}, action) => {
  switch (action.type) {
    case USER_STATUS.LOAD_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case USER_STATUS.LOAD_SUCCESS:
      const newState = { ...state, isLoading: false };
      const { timestamp, activeTimestamps } = action;
      const userState = newState[action.userId] || {
        activeTimestamps: []
      };
      userState.timestamp = timestamp;
      userState.activeTimestamps = activeTimestamps;
      // userState.activeTimestamps.push.apply(
      //   userState.activeTimestamps,
      //   activeTimestamps
      // );
      newState[action.userId] = userState;
      return newState;
    case USER_STATUS.LOAD_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.error
      };
    default:
      return state;
  }
};

export default userStatusReducer;



// WEBPACK FOOTER //
// ./src/reducers/userStatusReducer.js